module.exports = __webpack_public_path__ + "school/img/newVideoTrainingDirectoryTitle.ac47c97b.png";